import pluralize from 'pluralize'
import { upperFirst, lowerFirst } from 'lodash'

export class FormTitleFormatter {
  title = 'Forms'

  setTitle(title: string | null) {
    if (!title) {
      return
    }

    this.title = title
  }

  format(text: string) {
    const multipleTitle = this.title
    const singleTitle = pluralize.singular(multipleTitle)

    return text
      .replace(/\bForms\b/g, upperFirst(multipleTitle))
      .replace(/\bforms\b/g, lowerFirst(multipleTitle))
      .replace(/\bForm\b/g, upperFirst(singleTitle))
      .replace(/\bform\b/g, lowerFirst(singleTitle))
  }
}

export const formTitleFormatter = new FormTitleFormatter()
